import { render } from "./ProjectContainer.vue?vue&type=template&id=aba42f52"
import script from "./ProjectContainer.vue?vue&type=script&lang=js"
export * from "./ProjectContainer.vue?vue&type=script&lang=js"
script.render = render

export default script